/**
 * Effective value for "Enable call history in chat conversations".
 * When communicator-hide-chat-call-history is on, the setting is treated as
 * disabled without changing the stored preference (rollback-safe).
 */
export const resolveShowCallMessagesInChat = (
  savedValue: boolean | undefined,
  isHideChatCallHistoryEnabled: boolean
): boolean | undefined => {
  if (isHideChatCallHistoryEnabled) {
    return false;
  }

  return savedValue;
};
